/**
 * Practice details: the practice's HPI facility ID.
 *
 * Sent to labs with an eOrder - Awanui is told the order came from this facility, and won't open without it.
 * Anyone at the practice sees it; changing it needs PRACTICE_HPI_FACILITY_MANAGE.
 */
app.component("practiceHpiFacility", {
	templateUrl: "app/src/js/components/practiceHpiFacility/practiceHpiFacility.html",
	controller: "practiceHpiFacilityController",
	bindings: { practiceId: "<" },
});

app.controller("practiceHpiFacilityController", [
	"$scope",
	"Session",
	"PracticeService",
	function ($scope, Session, PracticeService) {
		const $ctrl = this;

		// F, two letters or digits, three digits, a hyphen and a check character, e.g. F2N060-C.
		const FACILITY_ID = /^F[A-Z0-9]{2}[0-9]{3}-[A-Z0-9]$/;

		$scope.canEdit = false;
		$scope.value = null;
		$scope.edit = { active: false, value: "" };
		$scope.state = { saving: false, error: null };

		$ctrl.$onChanges = function () {
			$scope.practiceId = $ctrl.practiceId || (Session.practice && Session.practice.id);
			const practice = findPractice();
			$scope.canEdit = Session.hasPermissionAt(practice, "PRACTICE_HPI_FACILITY_MANAGE");
			$scope.value = (practice && practice.hpi_facility_number) || null;
			$scope.cancel();
		};

		function findPractice() {
			return (Session.practiceOptions || []).find((p) => p.id === $scope.practiceId)
				|| (Session.practice && Session.practice.id === $scope.practiceId ? Session.practice : null);
		}

		const normalise = (text) => (text || "").trim().toUpperCase();

		$scope.isValid = () => {
			const value = normalise($scope.edit.value);
			return value === "" || FACILITY_ID.test(value);
		};

		$scope.start = function () {
			$scope.edit = { active: true, value: $scope.value || "" };
			$scope.state.error = null;
		};

		$scope.cancel = function () {
			$scope.edit = { active: false, value: "" };
			$scope.state.error = null;
		};

		$scope.save = function () {
			if (!$scope.canEdit || !$scope.isValid() || $scope.state.saving) return;
			$scope.state.saving = true;
			$scope.state.error = null;
			PracticeService.updateHpiFacility({ hpi_facility_number: normalise($scope.edit.value) || null }, $scope.practiceId)
				.then(function (resp) {
					const saved = (resp.data && resp.data.hpi_facility_number) || null;
					$scope.value = saved;
					// The practice copies the rest of the app reads, so the eOrders menu sees it straight away.
					[findPractice(), Session.practice]
						.filter((p) => p && p.id === $scope.practiceId)
						.forEach((p) => (p.hpi_facility_number = saved));
					$scope.edit = { active: false, value: "" };
				})
				.catch((resp) => ($scope.state.error = (resp && resp.data && resp.data.message) || "The HPI facility ID could not be saved."))
				.finally(() => ($scope.state.saving = false));
		};
	},
]);
